import { IStacCollection } from "types/stac";
import { LandingBanner } from "./Landing.Banner";
import Layout from "components/Layout";
import SEO from "components/Seo";
import { LandingCollections } from "./Landing.Collections";

interface LandingProps {
  name: string;
  collections?: IStacCollection[];
}

export const Landing = ({ name, collections }: LandingProps) => {
  return (
    <Layout isShort>
      <SEO title={name} />
      <div className="banner">
        <LandingBanner />
        <LandingCollections collections={collections} />
      </div>
    </Layout>
  );
};
